<mat-card class="multi-select-card">
    <div class="title">
        <label>{{ title }}</label>
        <span class="badge">{{ selectionCounter }}</span>
    </div>
    <div class="list" *ngIf="data$ | async as data; else loading">
        <div class="checkbox" *ngFor="let item of data">
            <div class="checkbox-wrapper">
                <mat-checkbox
                    color="primary"
                    [checked]="item.selected"
                    (change)="onItemSelectionChangeEvent(item, $event)"
                    >{{ item.text }}</mat-checkbox
                >
            </div>
        </div>
    </div>
    <ng-template #loading>
        <div class="loading-row" *ngFor="let x of [].constructor(10)">
            <ngx-skeleton-loader
                [count]="1"
                appearance="circle"
                [theme]="{
                    'border-radius': '2px',
                    height: '16px',
                    width: '16px'
                }"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
                [count]="1"
                appearance="line"
                [theme]="{
                    'border-radius': '2px',
                    height: '16px',
                    'margin-top': '0',
                    'margin-bottom': '0'
                }"
            ></ngx-skeleton-loader>
        </div>
    </ng-template>
</mat-card>
